module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_6005.72b03582.png";